import { apiFetch } from './client'

export interface HelpCompanyState {
  company_id: number | null
  has_logo: boolean
  has_signature: boolean
  has_company_profile: boolean
  has_retainage_default: boolean
  project_count: number
  pa_count: number
}

export interface DayOneChecklistItem {
  id: string
  label: string
  deep_link: string
  complete: boolean
}

export interface HelpGapRow {
  question: string
  route: string | null
  count: number
  last_asked: string
}

export async function fetchDayOneChecklist(): Promise<{
  state: HelpCompanyState
  items: DayOneChecklistItem[]
}> {
  const body = await apiFetch<{
    data: { state: HelpCompanyState; items: DayOneChecklistItem[] }
  }>('GET', '/api/help/day-one')
  return body.data
}

export async function fetchAdminHelpGaps(): Promise<HelpGapRow[]> {
  const body = await apiFetch<{ data: { gaps: HelpGapRow[] } }>('GET', '/api/admin/help-gaps')
  return body.data?.gaps ?? []
}
